import { render, staticRenderFns } from "./PaymentFinish.vue?vue&type=template&id=bf3b8bc2&scoped=true&"
import script from "./PaymentFinish.vue?vue&type=script&lang=js&"
export * from "./PaymentFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b8bc2",
  null
  
)

export default component.exports